import React, { useEffect } from "react";
import profile from "../../../images/profile.jpg";
import "./MainHeader.css";
import Aos from "aos";
import repairPlus from "../../../images/repair-plus.png";
import ponnoBilash from "../../../images/ponno-bilash.png";
import doctorsPortal from "../../../images/doctors-portal.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router";
import Typical from "react-typical";
import emailjs from "emailjs-com";

const MainHeader = () => {
  let history = useHistory();
  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);
  const handleClick = () => {
    history.push("/projects");
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "gmail",
        "template_xd42atp",
        e.target,
        "user_2x3Ql2qTnv7wocannrGlz"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };
  return (
    <div className="container pt-4">
      <div className="row d-flex align-items-center justify-content-between pb-5">
        <div
          data-aos="fade-right"
          className="col-md-6 col-sm-6 col-12 lh-lg text-white"
        >
          <h3>Hi There!</h3>
          <h1>I’M MD. RAISUL ISLAM</h1>
          <h3 className="dev fw-bold">
            <Typical
              steps={[
                "Web Developer",
                1000,
                "MERN Stack Developer",
                1000,
                "React Developer",
                1000,
                "JS Developer",
                1000,
              ]}
              loop={Infinity}
              wrapper="p"
            />
          </h3>
          <h6 className="lh-base text">
            Self-motivated Web Developer with a high level of experience working
            on multiple projects. Interested in roles with companies promoting
            best practices and offering diverse customer projects. I am
            available for any kind of job opportunity that suits my interests.
          </h6>
          <a
            href="https://www.linkedin.com/in/md-raisul-islam-ba1613168/"
            target="_blank"
            className="btn btn-success fw-bold"
          >
            Hire me
          </a>
        </div>
        <div data-aos="fade-left" className="col-md-6 col-sm-6 col-12">
          <img
            style={{ width: "60%", margin: "20px 50px" }}
            className="rounded"
            src={profile}
            alt=""
          />
        </div>
      </div>
      <div className="pt-5 text-center lh-base text-white">
        <h3>Some of my works</h3>
      </div>
      <div className="row row-cols-1 row-cols-md-3 g-4 pt-5 pb-5">
        <div className="col">
          <div className="card">
            <img src={repairPlus} className="card-img-top" alt="..." />
            <div className="card-body">
              <h5 className="card-title">Repair Plus</h5>
              <p className="card-text text">
                This is an electronic devices repair service based website.
                Users can review and show order lists and Admin can add, delete
                and also update any service.
              </p>
              <p>
                <strong>Technology:</strong> React.js, Node.js, Bootstrap,
                MongoDB, Firebase
              </p>
              <div className="card-footer d-flex justify-content-between">
                <a
                  className="link"
                  href="https://github.com/nibirbu24/repair-plus-client"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faGithub} /> Github
                </a>
                <a
                  className="link"
                  href="https://repair-plus-32417.web.app/"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faExternalLinkAlt} /> Live
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card">
            <img src={ponnoBilash} className="card-img-top" alt="..." />
            <div className="card-body">
              <h5 className="card-title">Ponno Bilash</h5>
              <p className="card-text text">
                This is an ecommerce site. Customers can login using email and
                password or google and order products online. Admin can add new
                products and delete any products.
              </p>
              <p>
                <strong>Technology:</strong> React.js, Node.js, Bootstrap,
                MongoDB, Firebase
              </p>
              <div className="card-footer d-flex justify-content-between">
                <a
                  className="link"
                  href="https://github.com/nibirbu24/ponno-bilash-client"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faGithub} /> Github
                </a>
                <a
                  className="link"
                  href="https://ponno-bilash.web.app/"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faExternalLinkAlt} /> Live
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card">
            <img src={doctorsPortal} className="card-img-top" alt="..." />
            <div className="card-body">
              <h5 className="card-title">Doctors Portal</h5>
              <p className="card-text text">
                In this project, users can get appointments from doctor. Users
                must have to login or signup to get appointment. Admin can add
                any doctor and Users can add reviews.
              </p>
              <p>
                <strong>Technology:</strong> React.js, Node.js, Bootstrap,
                MongoDB, Firebase
              </p>
              <div className="card-footer d-flex justify-content-between">
                <a
                  className="link"
                  href="https://github.com/nibirbu24/doctors-portal-client"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faGithub} /> Github
                </a>
                <a
                  className="link"
                  href="https://doctors-portal-c77ee.web.app/"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faExternalLinkAlt} /> Live
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center pb-3">
        <button onClick={handleClick} className="btn btn-primary">
          See More ...
        </button>
      </div>
      <div
        data-aos="fade-right"
        className="pt-5 text-center lh-base text-white"
      >
        <p>Thanks for visiting my site 😊</p>
        <h2>Get In Touch</h2>
        <h5>
          If you have any query, feel free to ask me. Be connected with me.
        </h5>
      </div>
      <div data-aos="fade-left" className="pt-5 pb-3">
        <div className="container col-md-8 col-12 bg-dark rounded p-5">
          <div className="section-header text-center text-white mb-5">
            <h3>Say Something</h3>
          </div>
          <div className="col-md-9 mx-auto">
            <form onSubmit={sendEmail}>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Your Name"
                  name="name"
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Your Email"
                  name="email"
                />
              </div>
              <div className="form-group">
                <textarea
                  className="form-control mb-3"
                  id=""
                  cols="30"
                  rows="10"
                  placeholder="Your Message"
                  name="message"
                ></textarea>
              </div>
              <div className="form-group text-center">
                <button type="submit" className="btn btn-primary">
                  {" "}
                  Send{" "}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainHeader;
